<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.billingId' | translate }}
  </label>
  <input type="text" class="form-control" id="billingId" formControlName="billingId"  [ngClass]="{ 'is-invalid': campaignForm.get('billingId')?.invalid}" />
  <div class="invalid-feedback" translate="field.required"></div>
</div>
